import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';
import { ReactNode } from 'react';
import { Control } from 'react-hook-form';

type InputFields =
  | 'plannerUrl'
  | 'imageUrl'
  | 'identifier'
  | 'team'
  | 'plannerContact';

type FormInputProps = {
  formControl: Control<PlannerConfigEntityWithOptionalFields>;
  name: InputFields;
  formLabel: ReactNode;
  formDescription: string;
  disabled: boolean;
};

function FormInputComponent({
  formControl,
  name,
  formLabel,
  formDescription,
  disabled,
}: FormInputProps) {
  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{formLabel}</FormLabel>
          <FormControl>
            <Input {...field} disabled={disabled} />
          </FormControl>
          <FormDescription>{formDescription}</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default FormInputComponent;
